module.exports = __webpack_public_path__ + "static/media/leaves bgWEB.c00b497c.jpg";